import type {
  TYPE_DESIRED_COLOR_OPTIONS,
  TYPE_MATERIAL_OPTIONS,
} from '../constants/colors-and-materials';
import type { TYPE_ROOM_TYPE_OPTIONS } from '../constants/room-type';
import { ROOM_COLOR_MAPPINGS, ROOM_MATERIAL_MAPPINGS } from '../constants/style-settings';

/**
 * Get room-specific color options for a given room type
 * @param roomType - The type of room (optional)
 * @returns Array of color options specific to the room type, or empty array if room type is not in mapping
 */
export const getRoomSpecificColors = (
  roomType?: TYPE_ROOM_TYPE_OPTIONS
): TYPE_DESIRED_COLOR_OPTIONS[] => {
  if (!roomType) {
    return [];
  }
  return ROOM_COLOR_MAPPINGS[roomType] || [];
};

/**
 * Get room-specific material options for a given room type
 * @param roomType - The type of room
 * @returns Array of material options specific to the room type, or empty array if room type is not in mapping
 */
export const getRoomSpecificMaterials = (
  roomType: TYPE_ROOM_TYPE_OPTIONS
): TYPE_MATERIAL_OPTIONS[] => {
  if (!roomType) {
    return [];
  }
  return ROOM_MATERIAL_MAPPINGS[roomType] || [];
};

/**
 * Get all available color options for a given room type
 * @param roomType - Optional room type for filtering
 * @returns Array of color options, or empty array if room type is not provided or not in mapping
 */
export const getAvailableColors = (
  roomType?: TYPE_ROOM_TYPE_OPTIONS
): TYPE_DESIRED_COLOR_OPTIONS[] => {
  if (roomType) {
    return getRoomSpecificColors(roomType);
  }
  return [];
};

/**
 * Get all available material options for a given room type
 * @param roomType - Optional room type for filtering
 * @returns Array of material options, or empty array if room type is not provided or not in mapping
 */
export const getAvailableMaterials = (
  roomType?: TYPE_ROOM_TYPE_OPTIONS
): TYPE_MATERIAL_OPTIONS[] => {
  if (roomType) {
    return getRoomSpecificMaterials(roomType);
  }
  return [];
};
